module.exports = __webpack_public_path__ + "img/dsci0126.045d1c9d.jpg";